import * as FullStory from '@fullstory/browser';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { getIsInitialized, isFullStoryEnabled, isNebulaDevCluster, } from '@thoughtspot/session-service';
import { FULLSTORY_ORG_ID } from './fullstory-constants';
import { identifyUserInFullStory } from './fullstory-identify';
const logger = create('FullStory Init');
const MAX_NUM_ATTEMPTS = 5;
const RETRY_INTERVAL_MS = 1000;
let isInitialized = false;
function inIFrame() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
export const initFullStory = (numAttempts = 1) => {
    const isSessionInfoInitialized = getIsInitialized();
    if (!isSessionInfoInitialized) {
        if (numAttempts < MAX_NUM_ATTEMPTS) {
            setTimeout(() => initFullStory(numAttempts++), RETRY_INTERVAL_MS);
        }
        else {
            logger.error('Could not initialize FullStory');
        }
        return;
    }
    if (!isFullStoryEnabled() || isFullStoryInitialized()) {
        return;
    }
    const orgId = FULLSTORY_ORG_ID;
    const debug = envFlags.getValue(FLAGS.debug.name) || false;
    const devMode = isNebulaDevCluster();
    if (inIFrame())
        window._fs_run_in_iframe = true;
    FullStory.init({ orgId, debug, devMode }, ({ sessionUrl }) => {
        identifyUserInFullStory();
        isInitialized = true;
    });
    if (devMode) {
        logger.info('Fullstory is initialized in dev mode: FullStory will shutdown recording and all subsequent SDK method calls will be no-ops.');
    }
};
export const isFullStoryInitialized = () => {
    return isInitialized && !!(window === null || window === void 0 ? void 0 : window.FS);
};
//# sourceMappingURL=fullstory-init.js.map